import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import { getQueryParams } from "app/pages/industry-analysis/common/getQueryParams";
import { getFlattenSelectedCategory } from "app/pages/industry-analysis/common/getSelectedCategory";
import { DefaultFetchService } from "app/services/fetchService";

const resolveMainIndustry = (flattenedCategory: IFlattenedCategory) => {
    const { isChild, parentItem, children = [], forApi } = flattenedCategory;
    if (isChild) {
        return parentItem.forApi;
    }
    const isParentWithoutChildren = children.length === 0;
    if (isParentWithoutChildren) {
        return undefined;
    }
    return forApi;
};

export const fetchData = <T>(endpoint: string): Promise<T> => {
    const fetchService = DefaultFetchService.getInstance();
    const baseQueryParams = getQueryParams();
    const flattenedCategory = getFlattenSelectedCategory();
    const mainIndustry = resolveMainIndustry(flattenedCategory);
    const includeMainOnly = !flattenedCategory.isChild && flattenedCategory.children?.length === 0;
    const queryParams = { ...baseQueryParams, mainIndustry, includeMainOnly };
    const rawDataPromise = fetchService.get<T>(endpoint, queryParams);
    return rawDataPromise;
};
